import { render, staticRenderFns } from "./PublicRouter.vue?vue&type=template&id=d0b20b52&scoped=true&"
import script from "./PublicRouter.vue?vue&type=script&lang=js&"
export * from "./PublicRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0b20b52",
  null
  
)

export default component.exports